import { tokens } from "../../../../theme";
import { Box, MenuItem, TextField, Typography, useTheme } from "@mui/material";
import Select from "../../../../components/SearchableSelect";
import { monoFont, refreshDrawerStyles } from "./styles";
import {
  BRANCH_HELPER,
  DEFAULT_BRANCH_FLAG,
  usesDefaultBranch,
} from "./helpers";

// Release target picker shared by Standard and Custom. Options arrive in API
// order; the shell already defaulted the selection to the first one. The base
// config branch rides along in the same card because it also describes *what
// the run targets*, not how much of the environment it touches.
const TargetSelect = ({
  title = "Target",
  label = "Release label",
  labels,
  releaseLabel,
  setReleaseLabel,
  helper,
  scope,
  setScope,
  baseConfigBranch,
  setBaseConfigBranch,
}) => {
  const theme = useTheme();
  const { refreshDrawer } = refreshDrawerStyles(tokens(theme.paletteId));
  const defaultBranch = usesDefaultBranch(scope);
  const setDefaultBranch = (on) =>
    setScope((prev) => ({ ...prev, [DEFAULT_BRANCH_FLAG]: on }));

  return (
    <Box sx={refreshDrawer.card}>
      {title ? (
        <Box sx={refreshDrawer.cardHead}>
          <Typography sx={refreshDrawer.cardTitle}>{title}</Typography>
        </Box>
      ) : null}
      <Box sx={refreshDrawer.cardBody}>
        <Box sx={refreshDrawer.fieldRow}>
          <Typography sx={refreshDrawer.fieldLabel}>{label}</Typography>
          <Select
            size="small"
            value={labels.includes(releaseLabel) ? releaseLabel : ""}
            onChange={(e) => setReleaseLabel(e.target.value)}
            sx={{ ...refreshDrawer.select, fontFamily: monoFont }}
            displayEmpty
            inputProps={{ "aria-label": label }}
          >
            {labels.length ? (
              labels.map((option) => (
                <MenuItem
                  key={option}
                  value={option}
                  sx={{ fontFamily: monoFont, fontSize: 13 }}
                >
                  {option}
                </MenuItem>
              ))
            ) : (
              <MenuItem value="" disabled>
                Loading labels…
              </MenuItem>
            )}
          </Select>
          {helper ? (
            <Typography sx={refreshDrawer.fieldHelper}>{helper}</Typography>
          ) : null}
        </Box>

        <Box sx={refreshDrawer.branchRow}>
          <Typography sx={refreshDrawer.fieldLabel}>
            Base config branch
          </Typography>
          <Box sx={refreshDrawer.segmentedPill} role="group">
            <Box
              component="button"
              type="button"
              aria-pressed={defaultBranch}
              sx={refreshDrawer.segment(defaultBranch)}
              onClick={() => setDefaultBranch(true)}
            >
              Release default
            </Box>
            <Box
              component="button"
              type="button"
              aria-pressed={!defaultBranch}
              sx={refreshDrawer.segment(!defaultBranch)}
              onClick={() => setDefaultBranch(false)}
            >
              Custom
            </Box>
          </Box>
          {defaultBranch ? (
            <Typography sx={refreshDrawer.branchReadOnly}>
              (release default)
            </Typography>
          ) : (
            <TextField
              size="small"
              autoFocus
              placeholder="e.g. release/0.149"
              value={baseConfigBranch}
              onChange={(e) => setBaseConfigBranch(e.target.value)}
              sx={refreshDrawer.monoInputCompact}
              inputProps={{ "aria-label": "Base config branch" }}
            />
          )}
          <Typography sx={refreshDrawer.branchHelper}>
            {BRANCH_HELPER}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default TargetSelect;
